<template>
  <div>
    <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
      <!--because it's home page for account-->
      <h3 class="page-title">Отчёт по офферам</h3>
    </div>
    <div class="main-content bg-white" v-if="$currentUser.role != 'account'">
      <div class="page-header">
        <h3 class="page-title">Офферы</h3>
      </div>
      <div class="row">
        <div class="col lg-12">
          <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            <span>{{ alertText }}</span>
          </b-alert>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
          <b-btn size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                 v-b-modal.createOffer>
            Добавить оффер
            <!--<i class="icon-fa icon-fa-pencil"></i>-->
          </b-btn>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" v-if="!isMobile">
          <b-button-group class="filterComponent" style="width: 100%!important;">
            <b-button variant="success" class="mr-1" v-on:click="selectAllRows"
                      size="sm">
              <i class="icon-fa icon-fa-check-square-o"></i>
            </b-button>
            <b-button variant="danger" class="mr-1" v-on:click="unselectAllRows"
                      size="sm">
              <i class="icon-fa icon-fa-close"></i>
            </b-button>
            <b-button variant="primary" class="mr-1" v-on:click="openMassUpdateModal"
                      size="sm">
              <i class="icon-fa icon-fa-edit"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
          <b-form-input placeholder="Поиск:"
                        size="sm"
                        class="sizePlus"
                        v-model="search"></b-form-input>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" :key="dateRange">
          <b-button-group  v-if="isXl" class="datePickerXl">
            <date-range-picker
                    ref="picker"
                    :locale-data="dateRangeLocalFormat"
                    v-model="range"
                    :opens="'right'"
                    :ranges="dateRanges"
                    @update="selectRange($event)">
              <template v-slot:input="picker" style="min-width: 350px;!important;">
                {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
              </template>
            </date-range-picker>
            <b-button size="sm" variant="primary">
              <i class="icon-fa icon-fa-calendar-check-o"></i>
            </b-button>
          </b-button-group>

          <b-input-group :key="dateRange" v-if="!isXl" class="">
            <div></div>
            <b-input-group-append>
              <datepicker input-class="form-control dateFrom"
                          class="date dateLeft"
                          size="sm"
                          v-model="range.startDate"
                          monday-first
                          :language="ru"
                          placeholder="С:">
              </datepicker>
              <datepicker input-class="form-control dateTo"
                          class="date dateRight"
                          size="sm"
                          v-model="range.endDate"
                          :language="ru"
                          monday-first
                          placeholder="По:">
              </datepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
          <b-form-select v-model="user"
                         size="sm"
                         class="sizePlus"
                         :options="users">
            <option :value="null" disabled>Создатель</option>
          </b-form-select>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
          <v-select label="name"
                    class=" geoComponent"
                    :options="geo" size="sm" required v-model="selectedGeo" placeholder="ГЕО"
                    multiple>
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
          <v-select
            size="sm"
            :options="advertisers"
            v-model="selectedAdvertisers"
            placeholder="Рекламодатель"
            :reduce="advertiser => advertiser.value"
            required
            multiple>
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </div>
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
          <v-select
            size="sm"
            :options="types"
            v-model="selectedTypes"
            :reduce="type => type.value"
            placeholder="Тип"
            required
            multiple>
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </div>
        <div class="myOffers col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
          <b-form-checkbox value="on"
                           style="display: inline !important;"
                           class="onlyMyCheckbox"
                           v-model="onlyMy">
            Мои офферы
          </b-form-checkbox>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2 applyButton">
          <b-input-group class="">
            <div></div>
            <b-input-group-append>
              <b-btn size="sm" text="Search" variant="success"
                     class="mainButton"
                     style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                     @click="getOffers(1, {sortBy: sortBy, sortDesc: sortDesc}, search, user)">
                Применить
                <!--<i class="icon-fa icon-fa-search"></i>-->
              </b-btn>
              <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                <!--<i class="icon-fa icon-fa-times"></i>-->
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div v-if="!isMobile">
            <b-table hover responsive bordered
                     selectable
                     ref="selectableTable"
                     no-select-on-click
                     small
                     :items="offers"
                     :fields="fields"
                     no-local-sorting
                     :sort-by.sync="sortBy"
                     @sort-changed="getOffers(1, $event, search)"
                     @row-clicked="rowClickHandler"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection">
              <template v-slot:cell(geo)="row">
                <div v-for="(item, index) in row.item.geo">
                  <div v-if="index < 2">{{ item }}</div>
                  <div v-if="index > 2 && index < 4">
                    <i class="icon-fa icon-fa-ellipsis-h" v-bind:id="'geoPopover' + row.item.id"
                       style="cursor: pointer;"></i>
                    <b-popover custom-class="offersPagePopover"
                               v-bind:target="'geoPopover' + row.item.id" triggers="click">
                      <template slot="title">Все страны</template>
                      <ol>
                        <li v-for="geoItem in row.item.geo">{{ geoItem }}</li>
                      </ol>
                    </b-popover>
                  </div>
                </div>
              </template>
              <template v-slot:cell(type)="row">
                <div v-if="row.item.type">
                  {{ row.item.type.label }}
                </div>
              </template>
              <template v-slot:cell(user_id)="row">
                <div>{{ row.item.user.name }}</div>
              </template>
              <template v-slot:cell(platforms)="row">
                <div v-for="(item, index) in row.item.platforms">
                  <div v-if="index < 2">{{ item }}</div>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button size="sm" class="btn btn-warning"
                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin'"
                          @click.stop="edit(row)">
                  <i class="icon-fa icon-fa-edit"></i>
                </b-button>
                <b-button size="sm" class="btn btn-danger"
                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin'"
                          @click.stop="deleteOffer(row.item)">
                  <i class="icon-fa icon-fa-trash-o"></i>
                </b-button>
              </template>
            </b-table>
          </div>
          <div v-if="isMobile">
            <b-table hover responsive bordered stacked
                     small
                     :items="offers"
                     :fields="fields"
                     no-local-sorting
                     :sort-by.sync="sortBy"
                     @sort-changed="getOffers(1, $event, search)"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection">
              <template v-slot:cell(geo)="row">
                <div v-for="(item, index) in row.item.geo">
                  <div v-if="index < 2">{{ item }}</div>
                  <div v-if="index > 2 && index < 4">
                    <i class="icon-fa icon-fa-ellipsis-h"></i>
                  </div>
                </div>
              </template>
              <template v-slot:cell(platforms)="row">
                <div v-for="(item, index) in row.item.platforms">
                  <div v-if="index < 2">{{ item }}</div>
                </div>
              </template>
              <template v-slot:cell(type)="row">
                <div v-if="row.item.type">
                  {{ row.item.type.label }}
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button size="sm" class="btn btn-warning"
                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin'"
                          @click.stop="edit(row)">
                  <i class="icon-fa icon-fa-edit"></i>
                </b-button>
                <b-button size="sm" class="btn btn-danger"
                          v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin'"
                          @click.stop="deleteOffer(row.item)">
                  <i class="icon-fa icon-fa-trash-o"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5">
          <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
        </div>
        <div class="col-sm-7">
          <div class="float-right">
            <nav aria-label="Page navigation">
              <ul class="pagination justify-content-center">
                <b-pagination size="sm" :total-rows="pager.total"
                              v-model="pager.current_page"
                              v-on:change="getOffers($event, {sortBy: sortBy, sortDesc: sortDesc}, search)"
                              :per-page="pager.per_page"></b-pagination>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <b-modal id="createOffer"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               ref="offerCreateModal" size="md" @hidden="hideCreateModal" title="Создать оффер"
               hide-footer>
        <CreateOfferModal></CreateOfferModal>
      </b-modal>

      <b-modal ref="offerEditModal"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               id="offerEditModal" size="md" title="Редактировать оффер" hide-footer>
        <EditOfferModal v-bind:offer="selectedOffer"></EditOfferModal>
      </b-modal>

      <b-modal id="massOfferUpdateModal" ref="massOfferUpdateModal"
               @ok="massUpdate"
               ok-title="Сохранить"
               cancel-title="Отмена"
               size="sm" title="Редактирование Офферов">
        <span class="alert-danger" v-for="error in massUpdateModal.errors">{{ error }}</span>
        <form>
          <b-form-group label="Тип">
            <v-select :options="types"
                      :reduce="type => type.value"
                      required
                      :searchable="false"
                      v-model="massUpdateModal.type">
            </v-select>
          </b-form-group>
          <b-form-group label="Гео">
            <v-select :options="geo" required v-model="massUpdateModal.geo" multiple>
              <span slot="no-options">Совпадений не найдено.</span>
            </v-select>
          </b-form-group>
          <b-form-group label="Платформа">
            <v-select :options="platforms" required v-model="massUpdateModal.platforms" multiple>
              <span slot="no-options">Совпадений не найдено.</span>
            </v-select>
          </b-form-group>
          <b-form-group label="Рекламодатель">
            <v-select
              :options="advertisers"
              :reduce="advertiser => advertiser.value"
              required
              v-model="massUpdateModal.selectedAdvertiser">
              <span slot="no-options">Совпадений не найдено.</span>
            </v-select>
          </b-form-group>
          <b-form-group label="Трекер">
            <v-select :options="trackers"
                      v-model="massUpdateModal.tracker">
            </v-select>
          </b-form-group>
          <b-form-group label="Валюта оффера">
            <v-select :options="currency" :searchable="false" required v-model="massUpdateModal.currency"></v-select>
          </b-form-group>
        </form>
      </b-modal>
    </div>
  </div>
</template>
<script>

import CreateOfferModal from './modals/CreateOfferModal.vue'
import OffersService from '../../services/offersDataService'
import EditOfferModal from './modals/EditOfferModal.vue'
import {ru} from '../../services/customLocaleDatepicker'
import Datepicker from 'vuejs-datepicker'

import advertiserFormMixin from "./mixins/Advertiser/advertiserFormMixin";
import offersDataService from "../../services/offersDataService";
import saveFiltersMixin from "./mixins/saveFiltersMixin";
import DateRangePicker from 'vue2-daterange-picker'

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";

export default {
  name: 'offers',
  mixins: [
    advertiserFormMixin,
    saveFiltersMixin,
    vue2DateRangePickerMixin
  ],
  components: {

    CreateOfferModal: CreateOfferModal,
    EditOfferModal: EditOfferModal,
    Datepicker: Datepicker,
    DateRangePicker: DateRangePicker

  },
  data() {
    return {
      offers: [],
      massUpdateModal: {
        selectedOffers: [],
        selectedAdvertiser: null,
        errors: [],
        geo: [],
        currency: null,
        platforms: [],
        tracker: null,
        advertiser_id: null,
        type: null
      },
      platforms: [],
      currency: [],
      trackers: [],
      alertText: '',
      showDismissibleAlert: false,
      pager: {},
      user: null,
      selectedGeo: [],
      selectedAdvertisers: [],
      selectedTypes: [],
      geo: [],
      users: [],
      onlyMy: false,
      dateFrom: null,
      dateTo: null,
      types: [
        {
          label: 'Белый',
          value: 'white'
        },
        {
          label: 'Серый',
          value: 'grey'
        },
        {
          label: 'Seo',
          value: 'seo'
        },
        {
          label: 'InfoBiz',
          value: 'infoBiz'
        },
        {
          label: 'Affiliate',
          value: 'Affiliate'
        }
      ],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'title',
          label: 'Название',
          sortable: true
        },
        {
          key: 'geo',
          label: 'ГЕО',
          sortable: true
        },
        {
          key: 'platforms',
          label: 'Платформа',
          sortable: true
        },
        {
          key: 'topic',
          label: 'Вертикаль',
          sortable: true
        },
        {
          key: 'type',
          label: 'Тип',
          sortable: true
        },
        {
          key: 'user_name',
          label: 'Создатель',
          sortable: true
        },
        {
          key: 'advertiser_legal_title',
          label: 'Рекламодатель',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Дата создания',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действия',
          tdAttr: {'align': "center"}
        }
      ],
      search: '',
      sortBy: 'created_at',
      sortDesc: true,
      sortDirection: 'desc',
      selectedOffer: null,
      isMobile: false,
      window: {
        width: 0,
        height: 0
      },
      pageSize: 50,
      isXl: false,
      ru: ru,
      savedFiltersName: 'offers'
    }
  },
  methods: {
    getOffers(page, sort, search, user) {
      this.massUpdateModal.selectedOffers = []

      if (this.useSavedFilters == true) {
        let filters = this.getFilters(this.savedFiltersName)

        if (filters) {
          page = filters.page
          sort = filters.sort
          this.search = filters.search

          this.range = this.dateConvert(filters.rangeStart, filters.rangeEnd)

          this.user = filters.user
          this.selectedGeo = filters.selectedGeo
          this.pageSize = filters.pageSize
          this.selectedAdvertisers = filters.selectedAdvertisers
          this.selectedTypes = filters.selectedTypes

        }
      }

      if (!page) {
        page = 1;
      }

      if (!sort) {
        sort = this;
      }
      let range = {
        endDate: null,
        startDate: null
      };

      range.endDate = this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : '';
      range.startDate = this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : '';

      if (!search) {
        search = this.search ? this.search : null
      }
      if (!user) {
        user = this.user
      }

      if (this.onlyMy) {
        user = this.$currentUser.id;
      }

      if (this.isMobile) {
        this.pageSize = 10;
      }

      let filtersObject = {
        page: page,
        sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
        search: search,
        rangeStart: range.startDate,
        rangeEnd: range.endDate,
        user: user,
        selectedGeo: this.selectedGeo,
        pageSize: this.pageSize,
        selectedAdvertisers: this.selectedAdvertisers,
        selectedTypes: this.selectedTypes
      }

      this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

      OffersService.getOffers(page, sort, search, range, user, false, this.selectedGeo, this.pageSize, this.selectedAdvertisers, this.selectedTypes)
        .then(offers => {
          offers.data.forEach(function (offerItem) {
            if (offerItem.type == 'white') {
              offerItem.type = {
                value: 'white',
                label: 'Белый'
              }
            }
            if (offerItem.type == 'grey') {
              offerItem.type = {
                value: 'grey',
                label: 'Серый'
              }
            }
            if (offerItem.type == 'seo') {
              offerItem.type = {
                value: 'seo',
                label: 'Seo'
              }
            }
            if (offerItem.type == 'infoBiz') {
              offerItem.type = {
                value: 'infoBiz',
                label: 'InfoBiz'
              }
            }
            if (offerItem.type == 'Affiliate') {
              offerItem.type = {
                value: 'Affiliate',
                label: 'Affiliate'
              }
            }
          });

          this.useSavedFilters = false
          this.pager = offers;
          this.offers = offers.data

        })
    },
    selectRange(event) {
      console.log(event)
      this.range = event;
    },
    resetFilters() {
      this.search = '';
      this.sortBy = 'updated_at';
      this.sortDesc = true;
      this.sortDirection = 'desc';
      this.user = null;
      this.range = {
        startDate: null,
        endDate: null
      };
      this.selectedGeo = [];
      this.selectedAdvertisers = [];
      this.selectedTypes = [];
      this.onlyMy = false;
      //re-initialize element
      this.dateRange++;

      this.getOffers();
    },

    rowClickHandler(row, index) {
      if (this.$refs.selectableTable.isRowSelected(index)) {
        this.$refs.selectableTable.unselectRow(index)
        let itemIndex = this.massUpdateModal.selectedOffers.indexOf(row.id)
        this.massUpdateModal.selectedOffers.splice(itemIndex, 1)
        return
      }

      if(this.validateRow(row)) {
        this.$refs.selectableTable.selectRow(index)
        this.massUpdateModal.selectedOffers.push(row.id)
      }

    },

    selectAllRows() {
      let ids = []
      this.offers.forEach((row, index) => {
        if (this.validateRow(row)) {
          this.$refs.selectableTable.selectRow(index)
          ids.push(row.id)
        }
      })

      if(ids.length !== 0 ) {
        this.massUpdateModal.selectedOffers = [...new Set([...this.massUpdateModal.selectedOffers, ...ids])]
      }
    },

    validateRow(row) {
      return row.user_id === this.$currentUser.id || this.$currentUser.role === 'admin';
    },

    unselectAllRows() {
      this.massUpdateModal.selectedOffers = []
      this.$refs.selectableTable.clearSelected()
    },

    openMassUpdateModal() {
      if (this.massUpdateModal.selectedOffers.length === 0) {
        this.alertText = 'Пожалуйста, выберите офферы.'
        this.showDismissibleAlert = true
        return
      }

      this.alertText = ''
      this.showDismissibleAlert = false
      this.massUpdateModal.selectedAdvertiser = null
      this.massUpdateModal.errors = []
      this.$refs.massOfferUpdateModal.show()
    },

    massUpdate(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.massUpdateModal.errors = [];

      offersDataService.massOfferUpdate(
        this.massUpdateModal
      ).then(response => {
        if(response.status === true) {
          this.$refs.massOfferUpdateModal.hide()
          this.unselectAllRows()
          this.getOffers()
          return
        }
        this.massUpdateModal.errors = [];
        this.massUpdateModal.errors = response.errors
      })
    },

    getUsers() {
      OffersService.getUsers()
        .then(users => {
          let usersArray = [];

          users.forEach(function (userItem) {
            let user = {};
            user.value = userItem.id;
            user.text = userItem.name;
            usersArray.push(user);
          });

          this.users = usersArray
        })
    },
    edit(item) {
      this.selectedOffer = item
      this.$refs.offerEditModal.show()
    },

    deleteOffer(offer) {
      this.$bvModal.msgBoxConfirm('ID: ' + offer.id + ' Название: ' + offer.title , {
        title: 'Вы точно уверены, что хотите удалить?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'ДА',
        cancelTitle: 'НЕТ',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value !== true) {
            return
          }

          if(! confirm('Точно удаляем?')) {
            return;
          }

          OffersService.deleteOffer(offer.id)
            .then(response => {
              if (response.success) {
                this.getOffers();

                toastr.success('Оффер удалён!')
              } else {
                toastr.error('Вы не можете удалить этот оффер. К нему привязаны данные.')
              }
            })
        })
        .catch(err => {
        })

    },
    getCountries() {
      OffersService.getCountries()
        .then(function (response) {
          let countries = [];

          response.forEach(function (item) {
            countries.push(item.code);
          });

          this.geo = countries;
        }.bind(this))
    },
    getCurrency() {
      OffersService.getCurrency()
        .then(function (response) {

          this.currency = response;
        }.bind(this))
    },
    getTrackers() {
      OffersService.getTrackers()
        .then(function (response) {

          this.trackers = response;
        }.bind(this))
    },
    getPlatforms() {
      OffersService.getPlatforms()
        .then(function (response) {

          this.platforms = response;
        }.bind(this))
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.isMobile = this.window.width < 415;
      this.isXl = this.window.width > 1199;
    },
    hideCreateModal() {
      this.getOffers();

      this.$refs.offerCreateModal.hide()
    },
    getNotAgencyFields() {
        return [
            {
                key: 'id',
                label: 'ID',
                sortable: true
            },
            {
                key: 'title',
                label: 'Название',
                sortable: true
            },
            {
                key: 'geo',
                label: 'ГЕО',
                sortable: true
            },
            {
                key: 'platforms',
                label: 'Платформа',
                sortable: true
            },
            {
                key: 'type',
                label: 'Тип',
                sortable: true
            },
            {
                key: 'user_name',
                label: 'Создатель',
                sortable: true
            },
            {
                key: 'advertiser_legal_title',
                label: 'Рекламодатель',
                sortable: true
            },
            {
                key: 'created_at',
                label: 'Дата создания',
                sortable: true
            },
            {
                key: 'actions',
                label: 'Действия',
                tdAttr: {'align': "center"}
            }
        ];
    }
  },
  beforeMount() {
    if (this.$currentUser.role == 'account') {
      window.location.href = '/offers-report'
    }

    if (this.$currentUser.department !== 'agency') {
       this.fields = this.getNotAgencyFields()
    }
    this.useSavedFilters = true

    this.getOffers()
    this.getUsers()
    this.getCountries()
    this.getAdvertisers()
    this.getCurrency()
    this.getTrackers()
    this.getPlatforms()
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>
<style>
.btn i {
  text-align: center !important;
}

.offersPagePopover .popover-body {
  max-height: 200px;
  overflow: scroll;
}

.vdp-datepicker input {
  background-color: white !important;
  width: 100% !important;
}

.dateFrom {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.dateTo {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.mainButton {
  width: 100%;
}

.sizePlus {
  height: 34px !important;
}

.filterComponent {
  height: 30px !important;
}

.filterComponent .vs__dropdown-toggle {
  height: 30px !important;
}

.filterComponent .input-date {
  height: 30px !important;
}

.filterComponent .dateFrom {
  height: 30px !important;
}

.filterComponent .dateTo {
  height: 30px !important;
}

.date {
  width: 100%;
}

.datePickerXl {
  min-width: 100% !important;
  max-width: 100% !important;
}

.input-group-append {
  width: 100%;
}

.input-date {
  border-top-left-radius: 0.2rem !important;
  border-bottom-left-radius: 0.2rem !important;
}

.myOffers {
  padding-top: 4px;
}

.geoComponent .vs__selected {
  margin: 2px 2px 4px 0 !important;
}

.table-sm th {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
  padding-left: 5px;
  width: .2em;
}
.reportrange-text {
  font-size: 0.9rem;
  min-width: 150px;
  width: 110%!important;
}

@media (max-width: 576px) {
  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }
}

@media (min-width: 768px) {
  .dateLeft .vdp-datepicker__calendar {
    right: 0 !important;
  }

  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .myOffers {
    max-width: 14.66666667% !important;
  }

  .input-date {
    width: 146px !important;
  }
}

@media (min-width: 1300px) {
  .input-date {
    width: 160px !important;
  }
}

@media (min-width: 1400px) {
  .input-date {
    width: 170px !important;
  }

  .myOffers {
    max-width: 12.66666667% !important;
  }
}

@media (min-width: 1500px) {
  .input-date {
    width: 190px !important;
  }
}

@media (min-width: 1600px) {
  .input-date {
    width: 200px !important;
  }

  .myOffers {
    max-width: 11.66666667% !important;
  }
}

@media (min-width: 1700px) {
  .input-date {
    width: 220px !important;
  }
}

@media (min-width: 1800px) {
  .input-date {
    width: 230px !important;
  }
}

@media (min-width: 1900px) {
  .input-date {
    width: 240px !important;
  }

  .myOffers {
    max-width: 9.66666667% !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/views/front/Offers.vue